module.exports = __webpack_public_path__ + "img/img_works16.68e406ef.jpg";